module.exports = __webpack_public_path__ + "media/images/Grubspotr-SpotrOS Logo-ceb2f26ad96dd6ba58753b62441e5a6e.svg";